import { CampaignFormData, Location, Creative } from '@/components/campaign/types';

export interface BudgetCalculations {
  totalCost: number;
  costPerDevice: number;
  costPerDay: number;
  [key: string]: any;
}

export interface DraftData {
  id: string;
  name: string;
  currentStep: number;
  selectedLocations: Location[];
  formData: CampaignFormData;
  duration: number;
  devices: number;
  creatives: Creative[];
  creativeUrls: string[];
  startDate: string;
  endDate: string;
  budgetCalculations: BudgetCalculations;
  locationCreatives: Record<string, Creative[]>;
  mediaOwnerCreatives: Record<string, Creative[]>;
  useLocationSpecificCreatives: boolean;
  useMediaOwnerSpecificCreatives: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface DraftStorageOptions {
  autoSave: boolean;
  debounceMs: number;
  syncToSession: boolean;
}

export const DEFAULT_DRAFT_OPTIONS: DraftStorageOptions = {
  autoSave: true,
  debounceMs: 500,
  syncToSession: true
};
